// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/catalog')({
  component: Outlet,
});
